const NOT_ASSIGNED = 'NA';

export const getUserTag = (name: string | undefined) =>
  name ? `${name?.split(' ')[0]?.charAt(0)}${name?.split(' ')[1]?.charAt(0)}` : NOT_ASSIGNED;
